import { Fragment, useState } from "react";
import { Button, Icon, Spacer, Theme } from "@dspworkplace/ui";
import ReminderCard from "./ReminderCard";
import { useFormContext } from "react-hook-form";
import { PUNCH_REMINDERS_VARIABLES, REMINDER_CARDS } from "./constants";
import Modal from "../../../../components/Modal";
import { Description, EditorWrapper, SpanTag, TextArea } from "./styled";

const ReminderCards = ({ station = null }) => {
    const { register, getValues, setValue } = useFormContext();
    const [modalState, setModalState] = useState({
        visible: false,
        cardData: null,
        message: ''
    });
    const [showDescription, setShowDescription] = useState(false);

    const handleVisible = (cardData) => {
        const message = getValues(`${cardData?.type}.message`) || '';
        setModalState({ visible: true, cardData: cardData, message });
    };

    const handleClose = () => {
        setModalState({ visible: false, cardData: null, message: '' });
    };

    const handleOnChange = (evt) => {
        const content = evt.target.value;
        setModalState((prev) => ({ ...prev, message: content || '', }));
    }

    const handleSave = () => {
        setValue(`${modalState.cardData?.type}.message`, modalState.message,);
        handleClose();
    }

    return (
        <>
            <input type="hidden" value={station} ref={register()} name="station" />
            {REMINDER_CARDS.map((card, index) => (
                <Fragment key={card.reminderId}>
                    <Spacer bottom={6} />
                    <ReminderCard cardData={card} handleVisible={handleVisible} />
                    <input type="hidden" name={`${card.type}.message`} ref={register()} />
                </Fragment>
            ))}
            <Modal width='750px' visible={modalState.visible} title='Edit Reminder Message' setVisible={handleClose} >
                <EditorWrapper>
                    <div>
                        <TextArea
                            id="previewMessage"
                            placeholder="Edit preview message..."
                            value={modalState.message}
                            onChange={handleOnChange}
                            rows={10}
                        />
                        <div style={{ width: "100%", cursor: "pointer" }} onClick={() => setShowDescription(!showDescription)}>
                            <SpanTag style={{ color: Theme.colors.neutrals.medium }}>
                                <Icon.Info
                                    size="16px"
                                    color={Theme.colors.neutrals.medium}
                                    style={{
                                        verticalAlign: "middle",
                                        position: "relative",
                                        top: -1,
                                    }}
                                />{" "}
                                Punch Reminders Message Variable
                            </SpanTag>
                        </div>
                        {showDescription && (
                            <Description>
                                {PUNCH_REMINDERS_VARIABLES.map(value => (
                                    <SpanTag key={value}>
                                        <span>{value}</span>
                                    </SpanTag>
                                ))}
                            </Description>
                        )}
                    </div>
                    <Button type='primary' Type='button' onClick={handleSave}>Save</Button>
                </EditorWrapper>
            </Modal>
        </>
    );
};

export default ReminderCards;
